import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DynamicGeographyTree from '../common/DynamicTree/DynamicGeographyTree';
import * as geographyActions from '../../actions/geographyActions';

class GeographiesV2 extends Component {
  constructor(props) {
    super(props);

    // this.props.geographyActions.handleSearchGeographyTreeLoad(
    //   this.props.loginResponse.data.token,
    //   this.props.loginResponse.data.uid,
    //   this.props.activeAccountId,
    //   this.props.moduleStudy.pn,
    //   { nodeId: 0, fname: null },
    // );
    this.reloadGeographies(this.props.moduleStudy.pn);
  }

  onFilterMouseUp = e => this.dynamicTree.onFilterMouseUp(e);

  reloadGeographies = pn => {
    this.props.geographyActions.handleSearchGeographyTreeLoad(
      this.props.loginResponse.data.token,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      pn,
      { nodeId: 0, fname: null },
    );
  }

  UNSAFE_componentWillReceiveProps = nextProps => {
    if (nextProps.refreshFlag !== this.props.refreshFlag) {
      this.reloadGeographies(nextProps.moduleStudy.pn);
    }
  }

  handleNodeClicked = (newNodes, currentNodes) => {
    if (currentNodes && currentNodes.length !== 0) {
      this.props.geographyActions.updateTreeLoad(currentNodes);
    }
    this.props.geographyActions.updateTreeLoad(newNodes);
    newNodes.forEach(node => {
      if (node.type !== 'L') {
        this.props.geographyActions.handleSearchGeographyTreeLoad(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          this.props.moduleStudy.pn,
          node,
        );
      }
    });
  };

  render() {
    const geographies = this.props.geographiesTree;
    const dictionaryHeight = this.props.noExpressionBox ? '50rem' : '25rem';
    return (
      <div className="questions-wrapper">
        <div className="expanded row">
          <div className="small-12 large-12 columns padding-left-0 padding-right-0 clearfix">
            <div className="dictionory-grid margin-bottom-o" style={{ height: dictionaryHeight }}>
              <DynamicGeographyTree
                treedata={geographies}
                onNodeClicked={this.handleNodeClicked}
                ref={dynamicTree => {
                  this.dynamicTree = dynamicTree;
                }}
                tabSelected="geographies"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

GeographiesV2.propTypes = {
  geographyActions: PropTypes.shape({
    updateTreeLoad: PropTypes.func,
    handleSearchGeographyTreeLoad: PropTypes.func,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      token: PropTypes.string,
      uid: PropTypes.number,
    }),
  }),
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  activeAccountId: PropTypes.number,
  noExpressionBox: PropTypes.bool,
  refreshFlag: PropTypes.bool,
  geographiesTree: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

function mapStateToProps(state) {
  return {
    geographiesTree: state.geographies.geographiesTree,
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    geographyActions: bindActionCreators(geographyActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GeographiesV2);
